import React from "react";

function MLMDevProcess() {
  return (
    <>
      <div className="project-style-one-area default-padding bg-gray blurry-shape-half-right-bottom">
        <div className="container">
          <div className="row">
            <div className="col-xl-4">
              <div className="fixed-content">
                <div className="site-heading">
                  <h4 className="sub-title">Latest Projects</h4>
                  <h2 className="title split-text-right split-text-in-right split-lines">
                    Our MLM Development Process
                  </h2>
                </div>
                <div className="project-fun-fact">
                  <div className="js-counter">2,650+</div>
                  <h4>
                    Finished creative projects successfully using AI support
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-xl-8 pl-50 pl-md-15 pl-xs-15">
              <div className="project-style-one-items">
                <div className="project-style-one-item">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/projects/5.jpg"
                      alt="Image Not Found"
                    />
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/shape/4.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <div className="">
                      <h3>Consultation & Requirements Gathering</h3>
                      <p>
                        We work closely with you to understand your business
                        model, define objectives, and determine the best MLM
                        structure for your needs.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="project-style-one-item">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/projects/6.jpg"
                      alt="Image Not Found"
                    />
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/shape/5.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <div className="">
                      <h3>MLM Plan Selection & Customization</h3>
                      <p>
                        Based on your goals, we help select and customize an MLM
                        plan that ensures optimal functionality and
                        profitability.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="project-style-one-item">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/projects/6.jpg"
                      alt="Image Not Found"
                    />
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/shape/6.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <div className="">
                      <h3>Platform Development & Integration</h3>
                      <p>
                        Our expert developers build and integrate essential
                        features, payment gateways, and security measures to
                        deliver a seamless user experience.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="project-style-one-item">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/projects/4.jpg"
                      alt="Image Not Found"
                    />
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/shape/6.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <div className="">
                      <h3>Testing & Quality Assurance</h3>
                      <p>
                        We rigorously test the platform for performance,
                        security, and scalability to ensure it’s ready for a
                        successful launch.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="project-style-one-item">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/projects/5.jpg"
                      alt="Image Not Found"
                    />
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/shape/6.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <div className="">
                      <h3>Launch & Ongoing Support</h3>
                      <p>
                        Our team assists with deployment and provides continuous
                        support, maintenance, and upgrades to keep your platform
                        running smoothly.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MLMDevProcess;
